import { render, staticRenderFns } from "./WXCW01Query.vue?vue&type=template&id=63264cde&"
import script from "./WXCW01Query.vue?vue&type=script&lang=js&"
export * from "./WXCW01Query.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports